var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrezor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38204 0C5.91342 0 3.10633 2.77769 3.10633 6.20997V8.53742C1.88829 8.75561 0.666748 9.04654 0.666748 9.42406V21.5704C0.666748 21.5704 0.666748 21.9064 1.04826 22.0657C2.43081 22.6198 7.86999 24.5247 9.11953 24.9611C9.28053 25.02 9.32604 25.02 9.36804 25.02C9.42754 25.02 9.45554 25.02 9.61654 24.9611C10.8661 24.5247 16.3193 22.6198 17.7018 22.0657C18.0553 21.9202 18.0693 21.5843 18.0693 21.5843V9.42406C18.0693 9.04654 16.8653 8.74176 15.6437 8.53742V6.20997C15.6612 2.77769 12.8367 0 9.38204 0ZM9.38204 2.96818C11.4261 2.96818 12.6616 4.19078 12.6616 6.21344V8.2361C10.3691 8.07678 8.41251 8.07678 6.10593 8.2361V6.21344C6.10593 4.18732 7.34147 2.96818 9.38204 2.96818ZM9.36804 11.2147C12.2206 11.2147 14.6147 11.4329 14.6147 11.8242V19.4023C14.6147 19.52 14.6007 19.5339 14.4957 19.5754C14.3942 19.6205 9.63055 21.321 9.63055 21.321C9.63055 21.321 9.43804 21.3799 9.38204 21.3799C9.32254 21.3799 9.13353 21.3072 9.13353 21.3072C9.13353 21.3072 4.36987 19.6066 4.26837 19.5616C4.16686 19.5166 4.14936 19.5027 4.14936 19.3884V11.8104C4.12136 11.419 6.51544 11.2147 9.36804 11.2147Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrezor);
export default __webpack_public_path__ + "static/media/Trezor.04ef0d2749ff0b9ae95e40f5a67d7256.svg";
export { ForwardRef as ReactComponent };